"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrlFromIds = void 0;
const URL_LIMIT = 2000;
function buildUrlFromIds(path, ids) {
    const initialPath = `${path}?ids=`;
    const remainingCharacters = URL_LIMIT - initialPath.length;
    const idLength = ids[0].length + 1; // + 1 for commas
    const idsToTake = Math.floor(remainingCharacters / idLength);
    return `${initialPath}${ids.splice(0, idsToTake).join(',')}`;
}
exports.buildUrlFromIds = buildUrlFromIds;
//# sourceMappingURL=buildUrlFromIds.js.map